import { render, staticRenderFns } from "./province.vue?vue&type=template&id=0bde9514&scoped=true&"
import script from "./province.vue?vue&type=script&lang=js&"
export * from "./province.vue?vue&type=script&lang=js&"
import style0 from "./province.vue?vue&type=style&index=0&id=0bde9514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde9514",
  null
  
)

export default component.exports